import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Apostille from "@/pages/Apostille";
import Scholarships from "@/pages/Scholarships";
import Notice from "@/pages/Notice";
import Alumni from "@/pages/Alumni";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Consultation from "@/pages/Consultation";
import AdditionalServices from "@/pages/AdditionalServices";
import Courses from "@/pages/Courses";
import Terms from "@/pages/Terms";
import Flipbook from "@/pages/Flipbook";
import Claritas from "@/pages/Claritas";
import StudyAbroad from "@/pages/StudyAbroad";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/study-abroad" element={<StudyAbroad />} />
          <Route path="/scholarships" element={<Scholarships />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/korean-language" element={<Courses />} />
          <Route path="/services" element={<Services />} />
          <Route path="/apostille" element={<Apostille />} />
          <Route path="/alumni" element={<Alumni />} />
          <Route path="/about" element={<About />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/additional-services" element={<AdditionalServices />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/flipbook" element={<Flipbook />} />
          <Route path="/claritas" element={<Claritas />} />
          <Route path="/luminosa" element={<Claritas />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
